/**
 * Apresentação «Formato lista» — produtos em linhas com quantidade directa.
 * Configuração em `tenant.theme_json.storeCatalogList`.
 * Exclusivo em relação à vitrine modular e ao catálogo luxo.
 */

/** @type {{ enabled: boolean, showSections: boolean, showPhotos: boolean }} */
export const STORE_CATALOG_LIST_DEFAULTS = {
  enabled: false,
  showSections: true,
  showPhotos: true,
};

/** @param {unknown} themeJson */
export function normalizeThemeJson(themeJson) {
  let obj = themeJson;
  if (typeof obj === 'string') {
    try {
      obj = JSON.parse(obj);
    } catch {
      return {};
    }
  }
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return {};
  return /** @type {Record<string, unknown>} */ (obj);
}

/**
 * @param {unknown} themeJson
 * @returns {{ enabled: boolean, showSections: boolean, showPhotos: boolean }}
 */
export function parseStoreCatalogList(themeJson) {
  const base = normalizeThemeJson(themeJson);
  const raw = base.storeCatalogList;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return { ...STORE_CATALOG_LIST_DEFAULTS };
  }
  return {
    enabled: Boolean(raw.enabled),
    showSections: raw.showSections !== false,
    showPhotos: raw.showPhotos !== false,
  };
}

/** @param {unknown} themeJson */
export function storeCatalogListBodyForEditor(themeJson) {
  const parsed = parseStoreCatalogList(themeJson);
  return {
    showSections: parsed.showSections,
    showPhotos: parsed.showPhotos,
  };
}
